export default __webpack_public_path__ + "static/rahu-logo-77cf961b5c4631574bca380cf47f8f48.svg";